import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";

@Injectable({
    providedIn: "root",
})
export class OpenAreaService {

    constructor(private apiService: ApiService) { }

    public checkSignature(args) {
        return this.apiService.callServicePostToCollectionCatalog("payment.signatureValidation", args);
    }

    public getBanks(args) {
        return this.apiService.callServicePostToCollectionCatalog("payment.banks", args);
    }

    public sendCode(args) {
        return this.apiService.callServicePostToCollectionCatalog("payment.sendCode", args);
    }

    public validateCode(args) {
        return this.apiService.callServicePostToCollectionCatalog("payment.validateCode", args);
    }

    public getPayment(args) {
        return this.apiService.callServicePostToCollectionCatalog("payment.pay", args);
    }

    public getPaymentStatus(args) {
        return this.apiService.callServicePostToCollectionCatalog("payment.status", args);
    }

    public setPaymentHistory(args) {
        return this.apiService.callServicePostToCollectionCatalog("payment.history", args);
    }
}
